import { ALL_OPTION } from '@/common/constants';
import { DefaultSortTypesEnum, Option } from '@/common/types';
import { IInvoiceStatusType, IInvoiceType } from '@/types';

export enum InvoiceMethod {
  PULL = 'PULL',
  PUSH = 'PUSH',
}

type InvoiceTypeViewType = Partial<Record<IInvoiceType, string>>;

export const InvoiceTypeView: InvoiceTypeViewType = {
  [IInvoiceType.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT]: 'Org Prefund',
  [IInvoiceType.PLAN_LEVEL_PREFUND_REPLENISHMENT]: 'Plan Prefund',
  [IInvoiceType.REPLENISHMENT]: 'Org Replenishment',
  [IInvoiceType.PLAN_LEVEL_REPLENISHMENT]: 'Plan Replenishment',
  [IInvoiceType.ORGANIZATION_LEVEL_CONTRIBUTIONS]: 'Org Contribution',
  [IInvoiceType.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT_RETURN]: 'Org Prefund Return',
  [IInvoiceType.PLAN_LEVEL_PREFUND_REPLENISHMENT_RETURN]: 'Plan Prefund Return',
  [IInvoiceType.PLAN_LEVEL_CONTRIBUTIONS]: 'Plan Contribution',
  [IInvoiceType.EOY_PLAN_RECONCILIATION]: 'EOY Plan Reconciliation',
  [IInvoiceType.BALANCE_ADJUSTMENT]: 'Balance Adjustment',
};

export const InvoiceMethodView: Record<InvoiceMethod, string> = {
  [InvoiceMethod.PULL]: 'Pull',
  [InvoiceMethod.PUSH]: 'Push',
};

export const INVOICES_STATUSES_OPTIONS: Option[] = [
  ALL_OPTION,
  {
    key: IInvoiceStatusType.PAYMENT_INITIATED,
    value: IInvoiceStatusType.PAYMENT_INITIATED,
    title: 'Payment initiated',
  },
  {
    key: IInvoiceStatusType.PAYMENT_REQUESTED,
    value: IInvoiceStatusType.PAYMENT_REQUESTED,
    title: 'Payment requested',
  },
  {
    key: IInvoiceStatusType.PAYMENT_REJECTED,
    value: IInvoiceStatusType.PAYMENT_REJECTED,
    title: 'Payment rejected',
  },
  {
    key: IInvoiceStatusType.PAID,
    value: IInvoiceStatusType.PAID,
    title: 'Paid',
  },
  {
    key: IInvoiceStatusType.PAYMENT_FAILED,
    value: IInvoiceStatusType.PAYMENT_FAILED,
    title: 'Payment failed',
  },
  {
    key: IInvoiceStatusType.REOPEN,
    value: IInvoiceStatusType.REOPEN,
    title: 'Reopen',
  },
  {
    key: IInvoiceStatusType.ACTION_REQUIRED,
    value: IInvoiceStatusType.ACTION_REQUIRED,
    title: 'Action required',
  },
  {
    key: IInvoiceStatusType.CANCELED,
    value: IInvoiceStatusType.CANCELED,
    title: 'Canceled',
  },
];

export const INVOICES_TYPES_OPTIONS: Option[] = [
  {
    ...ALL_OPTION,
  },
  {
    key: IInvoiceType.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT,
    value: IInvoiceType.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT,
    title: InvoiceTypeView.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT,
  },
  {
    key: IInvoiceType.PLAN_LEVEL_PREFUND_REPLENISHMENT,
    value: IInvoiceType.PLAN_LEVEL_PREFUND_REPLENISHMENT,
    title: InvoiceTypeView.PLAN_LEVEL_PREFUND_REPLENISHMENT,
  },
  {
    key: IInvoiceType.REPLENISHMENT,
    value: IInvoiceType.REPLENISHMENT,
    title: InvoiceTypeView.REPLENISHMENT,
  },
  {
    key: IInvoiceType.PLAN_LEVEL_REPLENISHMENT,
    value: IInvoiceType.PLAN_LEVEL_REPLENISHMENT,
    title: InvoiceTypeView.PLAN_LEVEL_REPLENISHMENT,
  },
  {
    key: IInvoiceType.ORGANIZATION_LEVEL_CONTRIBUTIONS,
    value: IInvoiceType.ORGANIZATION_LEVEL_CONTRIBUTIONS,
    title: InvoiceTypeView.ORGANIZATION_LEVEL_CONTRIBUTIONS,
  },
  {
    key: IInvoiceType.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT_RETURN,
    value: IInvoiceType.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT_RETURN,
    title: InvoiceTypeView.ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT_RETURN,
  },
  {
    key: IInvoiceType.PLAN_LEVEL_PREFUND_REPLENISHMENT_RETURN,
    value: IInvoiceType.PLAN_LEVEL_PREFUND_REPLENISHMENT_RETURN,
    title: InvoiceTypeView.PLAN_LEVEL_PREFUND_REPLENISHMENT_RETURN,
  },
  {
    key: IInvoiceType.PLAN_LEVEL_CONTRIBUTIONS,
    value: IInvoiceType.PLAN_LEVEL_CONTRIBUTIONS,
    title: InvoiceTypeView.PLAN_LEVEL_CONTRIBUTIONS,
  },
  {
    key: IInvoiceType.EOY_PLAN_RECONCILIATION,
    value: IInvoiceType.EOY_PLAN_RECONCILIATION,
    title: InvoiceTypeView.EOY_PLAN_RECONCILIATION,
  },
  {
    key: IInvoiceType.BALANCE_ADJUSTMENT,
    value: IInvoiceType.BALANCE_ADJUSTMENT,
    title: InvoiceTypeView.BALANCE_ADJUSTMENT,
  },
];
export const INVOICES_METHODS_OPTIONS: Option[] = [
  {
    ...ALL_OPTION,
  },
  {
    key: InvoiceMethod.PULL,
    value: InvoiceMethod.PULL,
    title: InvoiceMethodView.PULL,
  },
  {
    key: InvoiceMethod.PUSH,
    value: InvoiceMethod.PUSH,
    title: InvoiceMethodView.PUSH,
  },
];

export const SORTING_OPTIONS = [
  {
    key: DefaultSortTypesEnum.DESC,
    value: DefaultSortTypesEnum.DESC,
    title: 'Newest first',
  },
  {
    key: DefaultSortTypesEnum.ASC,
    value: DefaultSortTypesEnum.ASC,
    title: 'Oldest first',
  },
];
